(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    const kallaHeader = document.querySelector('.header--has-menu');
  const kallaMenus = document.querySelectorAll('header-menu.kalla-mega');
  let kallaCloseTimer = null;

  const closeKallaMenu = (menu) => {
    const details = menu.querySelector('details');
    if (details) details.open = false;
  };

  const openKallaMenu = (menu) => {
    window.clearTimeout(kallaCloseTimer);
    kallaMenus.forEach((other) => {
      if (other !== menu) closeKallaMenu(other);
    });
    const details = menu.querySelector('details');
    if (details && !details.open) details.open = true;
  };

  const scheduleCloseKallaMenus = () => {
    window.clearTimeout(kallaCloseTimer);
    kallaCloseTimer = window.setTimeout(() => {
      kallaMenus.forEach((menu) => closeKallaMenu(menu));
    }, 200);
  };

  const menuFromPoint = (x, y) => {
    const stack = document.elementsFromPoint(x, y);
    for (const element of stack) {
      if (!(element instanceof Element)) continue;
      const summary = element.closest('header-menu.kalla-mega > details > summary');
      if (summary) return summary.closest('header-menu.kalla-mega');
    }
    return null;
  };

  const hoveringOpenSheet = (x, y) => {
    const sheet = document.querySelector('header-menu.kalla-mega > details[open] .kalla-mega__sheet');
    if (!sheet) return false;
    const rect = sheet.getBoundingClientRect();
    const headerBottom = kallaHeader?.getBoundingClientRect().bottom ?? rect.top;
    return x >= rect.left && x <= rect.right && y >= headerBottom && y <= rect.bottom;
  };

  document.addEventListener('pointermove', (event) => {
    const menu = menuFromPoint(event.clientX, event.clientY);
    if (menu) {
      openKallaMenu(menu);
      return;
    }
    if (hoveringOpenSheet(event.clientX, event.clientY)) {
      window.clearTimeout(kallaCloseTimer);
      return;
    }
    const anyOpen = [...kallaMenus].some((item) => item.querySelector('details')?.open);
    if (anyOpen) scheduleCloseKallaMenus();
  });

  kallaMenus.forEach((menu) => {
    const summary = menu.querySelector('summary');

    summary?.addEventListener('click', (event) => {
      event.preventDefault();
      openKallaMenu(menu);
      window.setTimeout(() => openKallaMenu(menu), 0);
    });

    summary?.addEventListener('focusin', () => openKallaMenu(menu));
    menu.querySelector('.kalla-mega__panel')?.addEventListener('pointerenter', () => openKallaMenu(menu));
    menu.addEventListener('focusout', (event) => {
      const next = event.relatedTarget;
      if (next instanceof Element && (menu.contains(next) || next.closest('.kalla-mega__panel'))) return;
      window.setTimeout(() => {
        if (menu.contains(document.activeElement)) return;
        scheduleCloseKallaMenus();
      }, 0);
    });
  });

  kallaHeader?.addEventListener('pointerleave', (event) => {
    const next = event.relatedTarget;
    if (!(next instanceof Element)) {
      scheduleCloseKallaMenus();
      return;
    }
    if (next.closest('.kalla-mega__sheet') || next.closest('header-menu.kalla-mega > details > summary')) return;
    if (next.closest('.header--has-menu') && !next.closest('.kalla-mega__panel')) return;
    scheduleCloseKallaMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    window.clearTimeout(kallaCloseTimer);
    kallaMenus.forEach((menu) => closeKallaMenu(menu));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
      class StickyAddToCart extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
          this.button = this.querySelector('[data-sticky-submit]');
          this.price = this.querySelector('[data-sticky-price]');
          this.mainPrice = document.getElementById(`price-${this.dataset.sectionId}`);
          this.sync = this.sync.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.updateVisibility();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });

          if (this.mainButton) {
            this.sync();
            this.buttonObserver = new MutationObserver(this.sync);
            this.buttonObserver.observe(this.mainButton, {
              attributes: true,
              childList: true,
              subtree: true,
              attributeFilter: ['disabled', 'class', 'aria-disabled'],
            });
          }

          if (this.mainPrice && this.price) {
            this.priceObserver = new MutationObserver(this.sync);
            this.priceObserver.observe(this.mainPrice, { childList: true, subtree: true });
          }
        }

        disconnectedCallback() {
          this.buttonObserver?.disconnect();
          this.priceObserver?.disconnect();
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }

        onScroll() {
          if (this.scrollQueued) return;
          this.scrollQueued = true;
          requestAnimationFrame(() => {
            this.scrollQueued = false;
            this.updateVisibility();
          });
        }

        updateVisibility() {
          const anchor = this.mainButton;
          const visible = anchor
            ? anchor.getBoundingClientRect().bottom < 0
            : window.scrollY > 240;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }

        sync() {
          if (this.mainPrice && this.price && this.price.innerHTML !== this.mainPrice.innerHTML) {
            this.price.innerHTML = this.mainPrice.innerHTML;
          }

          if (!this.mainButton || !this.button) return;

          const label = this.mainButton.querySelector('span');
          const stickyLabel = this.button.querySelector('span');
          if (label && stickyLabel && stickyLabel.textContent !== label.textContent) {
            stickyLabel.textContent = label.textContent;
          }

          this.button.disabled = this.mainButton.disabled;
          if (this.mainButton.getAttribute('aria-disabled') === 'true') {
            this.button.setAttribute('aria-disabled', 'true');
          } else {
            this.button.removeAttribute('aria-disabled');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
